import { Component, OnInit } from '@angular/core';
import { HeaderService, AuthenticationService } from '../../_services';
import { TranslateService } from '@ngx-translate/core';
import { User } from 'src/app/_models';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';

declare const $ : any;

@Component({
  selector: 'app-error404',
  templateUrl: './error404.component.html',
  styleUrls: ['./error404.component.css']
})
export class Error404Component implements OnInit {

  public currentUser : User;
  public searchForm: FormGroup;

  constructor(
    private auth: AuthenticationService,
    public router : Router,
    public formBuilder: FormBuilder,
    public header : HeaderService,
    public translate : TranslateService,
  ) {
    this.header.setHeader(false,false,true,true);

    this.auth.currentUser.subscribe(user => {
      this.currentUser = user;
    });
  }

  ngOnInit() {
    
    // search
    this.searchForm = this.formBuilder.group({
      searchText: ['']  
    });
    
  }

  onSubmit(){
    const re  = /[àáèéìíòóùúçñÀÁÈÉÌÍÒÓÙÚÇÑ'-_\w\s]+/gi;
    const search = this.searchForm.controls.searchText.value.trim().match(re);
    if (search) {
      const query = search.join(' ').trim();
      this.router.navigate(['/search'], {  queryParams: { q : query }});
    }  
    this.searchForm.controls.searchText.setValue(''); 
  }


}
